import { Button, Text } from '@csscompany/csds-components';
import {
  FacilityInfo,
  ListCard,
  rosetta,
  useFacilitiesInfo,
} from '@csscompany/op-facility-finder';
import { navigate } from 'gatsby';
import React, { useCallback } from 'react';

import {
  LOCATIONS_COMPONENT_NAME,
  LOCATION_LIST_ID,
  LOG_PRODUCT_NAME,
} from '../../constants/facilityConstants';
import { useMixpanel } from '../../utils/mixpanel';
import { Button as CKButton } from '../ui';

type FacilityCardProps = {
  facility: FacilityInfo;
};

export const FacilityCard = ({ facility }: FacilityCardProps) => {
  const { mapClickedFacilityId, setFacilityScrollTop, setIsGoDetail } =
    useFacilitiesInfo();

  const mixpanelClient = useMixpanel();

  const onViewDetail = useCallback(
    (event) => {
      event.stopPropagation();
      setFacilityScrollTop(
        document.getElementById(LOCATION_LIST_ID)?.scrollTop
      );
      setIsGoDetail(true);

      mixpanelClient.track({
        product: LOG_PRODUCT_NAME,
        component: LOCATIONS_COMPONENT_NAME,
        event: 'Facility Card - Click View Details',
      });

      navigate(`./${facility.slug}`);
    },
    [facility]
  );

  return (
    <ListCard
      facility={facility}
      isSelected={mapClickedFacilityId === facility.id}
      detailsButton={
        <Button
          className="rounded-full"
          fullWidth={true}
          size="small"
          variant="secondary"
          emphasis="medium"
          onClick={onViewDetail}>
          <Text
            variant="$labelSmallBold"
            color="$staticTextWeak"
            style={{ textTransform: 'uppercase' }}>
            {rosetta.facility_card_view_details_button.getText()}
          </Text>
        </Button>
      }
      leadFormButton={
        <CKButton
          globalTypeform
          utm_content="ff-map-cta"
          size="sm"
          className="btn--bg btn--bg--primary w-full">
          <Text variant="$labelSmallBold">
            {rosetta.facility_card_book_tour_button.getText()}
          </Text>
        </CKButton>
      }
    />
  );
};
